module.exports = __webpack_public_path__ + "static/scrollable_image-29b883395ac0df06f83bf95d3f79a225.png";